/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Billing
 * API for managing HCP Billing Accounts.
 *
 * The version of the OpenAPI document: 2020-11-05
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * FlexVersion represents on which FLEX version this consumption pool contract was agreed.
 *
 *  - FLEX_VERSION_UNSPECIFIED: FLEX_VERSION_UNSPECIFIED is an invalid value, and means the field was left empty.
 *  - FLEX_VERSION_1: FLEX_VERSION_1 represents a v1 FLEX contract.
 *  - FLEX_VERSION_2: FLEX_VERSION_2 represents a v2 FLEX contract.
 * @export
 * @enum {string}
 */
export var Billing20201105FlexVersion;
(function (Billing20201105FlexVersion) {
    Billing20201105FlexVersion["UNSPECIFIED"] = "FLEX_VERSION_UNSPECIFIED";
    Billing20201105FlexVersion["_1"] = "FLEX_VERSION_1";
    Billing20201105FlexVersion["_2"] = "FLEX_VERSION_2";
})(Billing20201105FlexVersion || (Billing20201105FlexVersion = {}));
export function Billing20201105FlexVersionFromJSON(json) {
    return Billing20201105FlexVersionFromJSONTyped(json, false);
}
export function Billing20201105FlexVersionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function Billing20201105FlexVersionToJSON(value) {
    return value;
}
